export var PulseBetsTypes;
(function (PulseBetsTypes) {
    PulseBetsTypes["ThirtySecPulse"] = "1441";
    PulseBetsTypes["OneMinPulse"] = "1442";
    PulseBetsTypes["FiveMinPulse"] = "1443";
    PulseBetsTypes["TenMinPulse"] = "1444";
})(PulseBetsTypes || (PulseBetsTypes = {}));
//# sourceMappingURL=PulseBetsTypes.js.map